export default Object.freeze({
  SolicitudesAsignadas: 1,
  Todos: 2,
  SolicitudesInactivas: 4,
  CreadosPorMi: 5,
});
